var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Descriptive / Business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Descriptive-/-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Briefcase-4-Line",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99999987,5.00000015 L6.99999987,2.00000015 L6.99999987,2.00000015 C6.99999987,1.44771515 7.447715,1.00000015 7.99999987,1.00000015 L15.9999999,1.00000015 L15.9999999,1.00000015 C16.552285,1.00000015 16.9999999,1.44771515 16.9999999,2.00000015 L16.9999999,5.00000015 L20.9999999,5.00000015 L20.9999999,5.00000015 C21.5522849,5.00000015 21.9999999,5.44771515 21.9999999,6.00000015 L21.9999999,20.0000002 L21.9999999,20.0000002 C21.9999999,20.5522852 21.5522849,21.0000002 20.9999999,21.0000002 L2.99999987,21.0000002 L2.99999987,21.0000002 C2.44771487,21.0000002 1.99999987,20.5522852 1.99999987,20.0000002 C1.99999987,20.0000002 1.99999987,20.0000002 1.99999987,20.0000002 L1.99999987,6.00000015 L1.99999987,6.00000015 C1.99999987,5.4477153 2.44771487,5.00000015 2.99999987,5.00000015 L6.99999987,5.00000015 L6.99999987,5.00000015 Z M9,13 L4,13 L4,19 L20,19 L20,13 L15,13 L15,16 L9,16 L9,13 Z M20,7 L4,7 L4,11 L9,11 L9,9 L15,9 L15,11 L20,11 L20,7 Z M11,11 L11,14 L13,14 L13,11 L11,11 Z M9,3 L9,5 L15,5 L15,3 L9,3 Z",
    id: "Shape",
    fillOpacity: 0.64,
    fill: "#191923",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.16da0511a375785390f1e7fe03c7b8a8.svg";
export { ForwardRef as ReactComponent };